module.exports = __webpack_public_path__ + "static/media/Gerbera-Medium.a94671cb.otf";